import type { MessagePayload } from '@/actions/messages/sendMessage';
import type { OfferedPrompt } from '@/domain/message';
import { MESSAGE_SUB_TYPES, type PromptsSource } from '@/domain/messageEnums';

export interface ButtonPromptContext {
  launcherId: string;
  selectedPromptId: string;
  promptsSource: PromptsSource;
  offeredPrompts: OfferedPrompt[];
  pageUrl: string;
}

export function buildButtonPromptSelected(ctx: ButtonPromptContext): MessagePayload {
  const selected = ctx.offeredPrompts.find((prompt) => prompt.id === ctx.selectedPromptId);
  if (!selected) {
    throw new Error(
      `buildButtonPromptSelected: selectedPromptId "${ctx.selectedPromptId}" is not among the offered prompts`,
    );
  }

  return {
    subType: MESSAGE_SUB_TYPES.BUTTON_PROMPT_SELECTED,
    subTypeContent: {
      launcherId: ctx.launcherId,
      offeredPrompts: ctx.offeredPrompts,
      pageUrl: ctx.pageUrl,
      promptsSource: ctx.promptsSource,
      selectedPromptId: ctx.selectedPromptId,
    },
    text: selected.text, // the selected prompt's text verbatim (degradation net)
  };
}
